<template>
  <a-collapse
    v-model="activeKey"
    expandIconPosition="right"
    :bordered="false"
    class="outline-node"
  >
    <template #expandIcon="{ isActive }">
      <img
        src="@/assets/img/icon/icon8.png"
        alt=""
        :class="{ active: isActive }"
      />
    </template>
    <a-collapse-panel
      v-for="(el, index) in info"
      :key="el.id"
      :show-arrow="false"
      class="outline-class"
    >
      <template #header>
        <div class="class-title">
          <div>
            <img
              src="@/assets/img/sjxicon.png"
              alt=""
              class="outline-node-jt"
            />
            <span
              >第{{ index + 1 }}课<span>{{ el.chapterName }}</span></span
            >
          </div>
          <div :class="[`status-${el.studyStatus}`]">
            {{ el.studyStatus === "2" ? "已完成" : "未完成" }}
          </div>
        </div>
      </template>
      <RecordwareList v-if="el.contentList" :info="el.contentList" />
      <a-collapse
        v-model="activeKeyItem"
        expandIconPosition="right"
        :bordered="false"
        class="outline-node"
      >
        <template #expandIcon="{ isActive }">
          <img
            src="@/assets/img/icon/icon8.png"
            alt=""
            :class="{ active: isActive }"
          />
        </template>
        <a-collapse-panel
          v-for="(item, i) in el.children"
          :key="item.id"
          :show-arrow="false"
          class="outline-class"
        >
          <template #header>
            <div class="class-title speak" style="padding-left: 24px">
              <div>
                <img src="@/assets/img/yqicon.png" alt="" />
                <span
                  >第{{ i + 1 }}讲<span>{{ item.chapterName }}</span></span
                >
              </div>
              <div :class="[`status-${item.studyStatus}`]">
                {{ item.studyStatus === "2" ? "已完成" : "未完成" }}
              </div>
            </div>
          </template>
          <RecordwareList
            :padding="68"
            v-if="item.contentList"
            :info="item.contentList"
          />
        </a-collapse-panel>
      </a-collapse>
    </a-collapse-panel>
  </a-collapse>
</template>

<script>
import RecordwareList from "./recordwareList.vue";

export default {
  components: {
    RecordwareList,
  },
  props: {
    info: {
      type: Array,
      default: () => [],
    },
    distributeWay: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      activeKey: [],
      activeKeyItem: [],
    };
  },
};
</script>

<style scoped lang="scss">
.outline-node {
  .class-title {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: 400;
    color: #262626;
    line-height: 22px;
    > :first-child {
      width: 734px;
      padding-right: 24px;
      > img {
        margin-right: 8px;
      }
      > span {
        > span {
          margin-left: 8px;
        }
      }
    }
    > :nth-child(2) {
      width: 52px;
      height: 22px;
      border-radius: 11px;
      border: 1px solid #ff4d4f;
      font-size: 12px;
      font-weight: 400;
      color: #ff4d4f;
      line-height: 20px;
      text-align: center;
    }
    .status-1 {
      border-color: #ff4d4f;
      color: #ff4d4f;
    }
    .status-2 {
      border-color: #52c41a;
      color: #52c41a;
    }
  }
  .speak {
    > :first-child {
      width: 710px;
    }
  }
  .outline-node-jt {
    transition: all 0.3s;
  }
  ::v-deep .ant-collapse-item-active {
    .outline-node-jt {
      transform: rotate(90deg);
    }
  }
}
</style>
